import { Box, Button } from "@mui/material";
import JoinedLeaguesTable from "./joinedLeaguesTable";

export default function JoinedLeagues() {
  return (
    <div>
      <p className="heading-title">Joined Leagues</p>

      <Box mt={1}>
        <JoinedLeaguesTable />
      </Box>
    </div>
  );
}
